import './style.css';
import htmlFrag from './content.frag.html';

export async function initTechGiantsExposed () {
  const $dom = document.querySelector('#tech-giants-exposed');
  $dom.innerHTML = htmlFrag;
}
